import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-browse-constraints',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './browse-constraints.component.html',
    styleUrl: './browse-constraints.component.scss'
})
export class BrowseConstraintsComponent {

    @Input() constraints: string[] = [];
}
